import { isEmpty } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { levelMap } from "../../Utils/Constant";
import AuthContext from "../../context/AuthContext";
import MyAccountContext from "../../context/MyAccountContext";
import { useContextSelector } from "use-context-selector";

const MyAccountLayout = ({ children }) => {
  const location = useLocation();
  let activeClass = location?.pathname?.split("/")[2];
  const { id, type } = useParams();
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const returnUrl = (url) => {
    if (!isEmpty(id)) {
      return `${url}/${id}/${type}`;
    } else {
      return url;
    }
  };
  const [summaryData, setSummaryData] = useState("");
  const accountId = !isEmpty(id) ? id : user?._id;
  const accountSummary = useCallback(async () => {
    if (!accountId) return;

    const url = `${apiPath.userProfile}?user_id=${accountId}`;
    const { status, data: response_users } = await apiGet(url);
    if (status === 200) {
      if (response_users.success) {
        setSummaryData(response_users?.results);
      }
    }
  }, [accountId]);
  useEffect(() => {
    accountSummary();
  }, [accountSummary]);
  const accountContext = useMemo(
    () => ({ summaryData, setSummaryData, refreshSummary: accountSummary }),
    [summaryData, accountSummary],
  );
  return (
    <app-my-account _nghost-serverapp-c80>
      {!isEmpty(id) && (
        <div _ngcontent-serverapp-c112 className="main_wrap">
          <div _ngcontent-serverapp-c112 className="marquee-box">
            <h4 _ngcontent-serverapp-c112>News</h4>
            <div _ngcontent-serverapp-c112 className="marquee">
              <div _ngcontent-serverapp-c112 className="marquee-content">
                <span
                  _ngcontent-serverapp-c112
                  className="ticker-item ng-star-inserted"
                >
                  Welcome to Exchange
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      <div _ngcontent-serverapp-c80 className="main_wrap">
        <div _ngcontent-serverapp-c80 className="agent_path">
          <ul _ngcontent-serverapp-c89 id="agentPath" className="agent_path-L">
            <li _ngcontent-serverapp-c89 className="last_li">
              <a _ngcontent-serverapp-c89 href="#/users/5">
                <span
                  _ngcontent-serverapp-c89
                  className={`Bdlevel ${levelMap[isEmpty(id) ? user?.userType : summaryData?.userType]}`}
                />
                <strong _ngcontent-serverapp-c89>
                  {isEmpty(id) ? user?.username : summaryData?.username}
                </strong>
              </a>
            </li>
            <ul
              _ngcontent-serverapp-c89
              id="accountPop"
              className="account_pop"
            >
              <li
                _ngcontent-serverapp-c89
                id="popTmp"
                style={{ display: "none" }}
              >
                <a _ngcontent-serverapp-c89 />
              </li>
            </ul>
          </ul>
        </div>
        <div _ngcontent-serverapp-c80 className="col-left">
          <div _ngcontent-serverapp-c80 className="sub_path">
            <ul _ngcontent-serverapp-c80 className="menu-list">
              <li _ngcontent-serverapp-c80 className="class">
                Position
              </li>
              {isEmpty(id) && (
                <li _ngcontent-serverapp-c80>
                  <Link
                    _ngcontent-serverapp-c80
                    id="accountStatement"
                    to={returnUrl("/my-account/account-statement")}
                    className={
                      activeClass == "account-statement" ? "select" : ""
                    }
                  >
                    Account Statement
                  </Link>
                </li>
              )}
              <li _ngcontent-serverapp-c80>
                <Link
                  _ngcontent-serverapp-c80
                  id="accountSummary"
                  to={returnUrl("/my-account/account-summary")}
                  className={activeClass == "account-summary" ? "select" : ""}
                >
                  Account Summary
                </Link>
              </li>
              <li _ngcontent-serverapp-c80 className="class">
                Account Details
              </li>
              {type == "user" && (
                <>
                  <li _ngcontent-serverapp-c80>
                    <Link
                      _ngcontent-serverapp-c80
                      id="accountStatement"
                      to={returnUrl("/my-account/account-statement")}
                      className={
                        activeClass == "account-statement" ? "select" : ""
                      }
                    >
                      Account Statement
                    </Link>
                  </li>
                  <li _ngcontent-serverapp-c86="">
                    <Link
                      _ngcontent-serverapp-c86=""
                      id="currentbets"
                      className={activeClass == "current-bets" ? "select" : ""}
                      to={returnUrl("/my-account/current-bets")}
                    >
                      Current Bets
                    </Link>
                  </li>
                  <li _ngcontent-serverapp-c86="">
                    <Link
                      _ngcontent-serverapp-c86=""
                      id="bettingHistory"
                      className={
                        activeClass == "betting-history" ? "select" : ""
                      }
                      to={returnUrl("/my-account/betting-history")}
                    >
                      Betting History
                    </Link>
                  </li>
                  <li _ngcontent-serverapp-c86="">
                    <Link
                      _ngcontent-serverapp-c86=""
                      id="profitLoss"
                      className={activeClass == "profit-loss" ? "select" : ""}
                      to={returnUrl("/my-account/profit-loss")}
                    >
                      Betting Profit &amp; Loss
                    </Link>
                  </li>

                  <li _ngcontent-serverapp-c86="">
                    <Link
                      _ngcontent-serverapp-c86=""
                      id="profitLoss"
                      className={activeClass == "allcasnio-pnl" ? "select" : ""}
                      to={returnUrl("/my-account/allcasnio-pnl")}
                    >
                      All Casino Profit &amp; Loss
                    </Link>
                  </li>

                  <li _ngcontent-serverapp-c86="">
                    <Link
                      _ngcontent-serverapp-c86=""
                      id="awccasino-bethistory"
                      className={
                        activeClass == "parlay-bethistory" ? "select" : ""
                      }
                      to={returnUrl("/my-account/parlay-bethistory")}
                    >
                      Parlay Betting History
                    </Link>
                  </li>
                  {/* <li _ngcontent-serverapp-c86="">
                    <Link
                      _ngcontent-serverapp-c86=""
                      id="awccasino-bethistory"
                      className={
                        activeClass == "bogcasino-bethistory" ? "select" : ""
                      }
                      to={returnUrl("/my-account/bogcasino-bethistory")}
                    >
                      BO Casino Betting History
                    </Link>
                  </li>

                  <li _ngcontent-serverapp-c86="">
                    <Link
                      _ngcontent-serverapp-c86=""
                      id="awccasino-profitloss"
                      className={
                        activeClass == "bogcasino-profitloss" ? "select" : ""
                      }
                      to={returnUrl("/my-account/bogcasino-profitloss")}
                    >
                      BO Casino Profit &amp; Loss
                    </Link>
                  </li> */}
                  <li _ngcontent-serverapp-c86="">
                    <Link
                      _ngcontent-serverapp-c86=""
                      id="awccasino-bethistory"
                      className={
                        activeClass == "awccasino-bethistory" ? "select" : ""
                      }
                      to={returnUrl("/my-account/awccasino-bethistory")}
                    >
                      AWC Casino Betting History
                    </Link>
                  </li>
                  <li _ngcontent-serverapp-c86="">
                    <Link
                      _ngcontent-serverapp-c86=""
                      id="awccasino-profitloss"
                      className={
                        activeClass == "awccasino-profitloss" ? "select" : ""
                      }
                      to={returnUrl("/my-account/awccasino-profitloss")}
                    >
                      {" "}
                      AWC Casino Profit &amp; Loss{" "}
                    </Link>
                  </li>
                </>
              )}
              {isEmpty(id) && (
                <>
                  <li _ngcontent-serverapp-c80>
                    <Link
                      _ngcontent-serverapp-c80
                      id="profile"
                      to={returnUrl("/my-account/profile")}
                      className={activeClass == "profile" ? "select" : ""}
                    >
                      Profile
                    </Link>
                  </li>
                </>
              )}{" "}
              {!isEmpty(id) && (
                <li _ngcontent-serverapp-c86="">
                  <Link
                    _ngcontent-serverapp-c86=""
                    id="transactionHistory"
                    className={
                      activeClass == "transaction-history" ? "select" : ""
                    }
                    to={returnUrl("/my-account/transaction-history")}
                  >
                    Transaction History{" "}
                  </Link>
                </li>
              )}
              <li _ngcontent-serverapp-c80>
                <Link
                  _ngcontent-serverapp-c80
                  id="activityLog"
                  to={returnUrl("/my-account/login-history")}
                  className={activeClass == "login-history" ? "select" : ""}
                >
                  Activity Log
                </Link>
              </li>{" "}
            </ul>
          </div>
        </div>
        <MyAccountContext.Provider value={accountContext}>
          {children}
        </MyAccountContext.Provider>
      </div>
    </app-my-account>
  );
};

export default MyAccountLayout;
